import type { CoupleRhythmResponse } from '../../../contracts/api'
import { SEAL_COLORS } from '../../colors'

/**
 * Тринадцать дней двоих одной картинкой: верхняя полоса — ты, нижняя — второй
 * человек. Точка на день, цвет — печать этого дня; «свои» дни помечены точкой
 * под кружком, а дни, где печать общая, обведены золотом — только ради них
 * полосы и стоят одна над другой.
 */
const FIELD_WIDTH = 300
const FIELD_HEIGHT = 88
const MARGIN = 16
const ROW_FIRST = 30
const ROW_SECOND = 66

type WaveDay = CoupleRhythmResponse['wave']['days'][number]

function Row({ y, days, side }: { y: number; days: WaveDay[]; side: 'first' | 'second' }) {
  const step = days.length > 1 ? (FIELD_WIDTH - MARGIN * 2) / (days.length - 1) : 0
  return (
    <g>
      <line
        x1={MARGIN}
        y1={y}
        x2={FIELD_WIDTH - MARGIN}
        y2={y}
        style={{ stroke: 'var(--line2)' }}
        strokeWidth={1.5}
      />
      {days.map((day, index) => {
        const x = MARGIN + step * index
        const person = day[side]
        const color = SEAL_COLORS[person.color] ?? 'var(--gold)'
        return (
          <g key={day.date}>
            {day.both && (
              <circle cx={x} cy={y} r={9} fill="none" style={{ stroke: 'var(--gold)' }} strokeWidth={1.5} />
            )}
            <circle cx={x} cy={y} r={5} style={{ fill: color, stroke: color }} strokeWidth={1.5} />
            {person.mine && <circle cx={x} cy={y + 11} r={2.2} style={{ fill: 'var(--gold)' }} />}
          </g>
        )
      })}
    </g>
  )
}

export function PairWave({ days, partnerName }: { days: WaveDay[]; partnerName: string }) {
  if (days.length === 0) return null
  const partner = partnerName.length > 14 ? `${partnerName.slice(0, 13)}…` : partnerName

  return (
    <svg
      className="viz viz-pairwave"
      viewBox={`0 0 ${FIELD_WIDTH} ${FIELD_HEIGHT}`}
      width="100%"
      role="img"
      aria-label={`Тринадцать дней: ты и ${partnerName}`}
    >
      <text x={MARGIN - 2} y={ROW_FIRST - 14} className="viz-cap">
        ты
      </text>
      <Row y={ROW_FIRST} days={days} side="first" />
      <text x={MARGIN - 2} y={ROW_SECOND - 14} className="viz-cap">
        {partner}
      </text>
      <Row y={ROW_SECOND} days={days} side="second" />
    </svg>
  )
}
